// extracted by mini-css-extract-plugin
export default {"overlay":"TermsModal_overlay__PQWPc","modal":"TermsModal_modal__g-Fj1","content":"TermsModal_content__jS9BP","closeBtn":"TermsModal_closeBtn__MEakx"};